import { infiniteQueryOptions } from '@tanstack/react-query'
import getOrderList from '../api/get-order-list'

export const FINISHED_ORDERS_QUERY_KEY = ['orders', 'finished'] as const

export const finishedOrdersQueryOptions = infiniteQueryOptions({
  queryKey: FINISHED_ORDERS_QUERY_KEY,
  queryFn: async ({ pageParam }) => getOrderList({ isCurrent: false, after: pageParam }),
  initialPageParam: null as string | null,
  getNextPageParam: lastPage => lastPage.pageInfo.endCursor,
})
